import type {
  DataFilterDefinitionsDtoResponse,
  DataTableDataSearchDto,
} from '@asset-metrix/portal-gateway-client-js';
import { QueryFunction } from '@tanstack/react-query';

import { extractErrorMessage } from '../../utils/errorMessage';
import {
  QueryKeyWithRole,
  unwrapQueryKeyWithRole,
} from '../../utils/prependRoleId';
import { HttpError } from '../errors';
import { portalGatewayClient } from '../portalGatewayClient';

export type PageFilterQueryKey = readonly [
  { pageId: string; filterKey: string },
  pageFilterSelections: DataTableDataSearchDto['selection'],
  globalFilterSelections?: DataTableDataSearchDto['selection'],
  ...string[],
];

export const fetchPageFilterData: QueryFunction<
  DataFilterDefinitionsDtoResponse,
  QueryKeyWithRole<PageFilterQueryKey>
> = async ({ queryKey }) => {
  const [{ pageId }, pageFilterSelections, globalFilterSelections] =
    unwrapQueryKeyWithRole(queryKey).params;

  try {
    const response = await portalGatewayClient.pageFilter.searchPageFilterData(
      pageId,
      {
        selection: pageFilterSelections,
        filters: globalFilterSelections ?? undefined,
      }
    );

    if (response.ok) {
      return response.data;
    }

    throw new HttpError(
      extractErrorMessage(response.error, 'Error fetching page filter data'),
      response
    );
  } catch (e: unknown) {
    console.error(e);
    throw e;
  }
};
